const UI = {
    POOP: '💩',
    RESOURCES: {
        GOLD: {
            icon: '💰', name: 'Gold',
        },
        CRYST: {
            icon: '💠', name: 'Cryst',
        },
        GEMS: {
            icon: '💎', name: 'Gems',
        },
    },
    MENU: {
        icon: '☰', name: 'Menu',
    },
    MORE: {
        icon: '…', name: 'More',
    },
    CASINO: {
        icon: '🎰', name: 'Casino',
    },
    GAMBLE: {
        icon: '🎲', name: 'Gamble',
    },
    SHOP: {
        icon: '🛍️', name: 'Shop',
    },
    INVENTORY: {
        icon: '🎒', name: 'Inventory',
    },
    MISC: {
        QUESTION_MARK_1: {
            icon: '❓', name: 'Question Mark',
        },
        QUESTION_MARK_2: {
            icon: '❔', name: 'Question Mark',
        },
        EXCLAMATION_MARK_1: {
            icon: '❗', name: 'Exclamation Mark',
        },
        EXCLAMATION_MARK_2: {
            icon: '❕', name: 'Exclamation Mark',
        },
    },
    UI: {
        SKIP: {
            icon: '⏩', name: 'Skip',
        },
        REPEAT: {
            icon: '🔁', name: 'Repeat',
        },
        CHECK: {
            icon: '✔️', name: 'Check',
        },
        MULTIPLY: {
            icon: '✖️', name: 'Multiply',
        },
        DIVISION: {
            icon: '➗', name: 'Division',
        },
        PLUS: {
            icon: '➕', name: 'Plus',
        },
        MINUS: {
            icon: '➖', name: 'Minus',
        },
        CORRECT: {
            icon: '⭕', name: 'Correct',
        },
        WRONG: {
            icon: '❌', name: 'Wrong',
        },
    },
    STATS: {
        BELIEVE: {
            icon: '🛐', name: 'Believe',
        },
        PHYSICAL: {
            icon: '🛐', name: 'Believe',
        },
        MAGIC: {
            icon: '🔯', name: 'Believe',
        },
    },
    ELEMENTS: {
        AIR: {
            icon: '🌪', name: 'Air',
        },
        FIRE: {
            icon: '🔥', name: 'Fire',
        },
        EARTH: {
            icon: '🥔', name: 'Earth',
        },
        WATER: {
            icon: '💧', name: 'Water',
        },
    },
}

export default UI
